export const XSMALL = '12px';
export const SMALL = '14px';
export const MEDIUM = '16px';
export const LARGE = '20px';
export const XLARGE = '24px';
export const XXLARGE = '35px';
export const XXXLARGE = '46px';
export const blissPro = 'BlissPro';
export const sourceSansPro = 'SourceSansPro';

export const fonts = {
  blissPro: 'BlissPro',
  sourceSansPro: 'SourceSansPro',
};

export default {
  XSMALL,
  SMALL,
  MEDIUM,
  LARGE,
  XLARGE,
  XXLARGE,
  XXXLARGE,
  blissPro,
  sourceSansPro,
  fonts,
};
